<template>
  <div class="text-left">
    <div class="flex justify-between -mb-4">
      <div class="title">
        <slot name="title">title</slot>
      </div>
      <div>
        <router-link :to="{ name: 'Product',query:query }">
          <span class="font-bold more">{{ $t("更多") }}</span>
        </router-link>
      </div>
    </div>

    <div class="flex mt-6">
      <div class="mr-3 w-1/6 flex-auto">
        <div class="py-[0.35rem] h-full">
          <img class="img card" :src="img" alt @click="toPath"/>
        </div>
      </div>
      <div class="w-5/6">
        <PublicList v-bind="$attrs" v-slot="{ item }">
          <Item :item="item"></Item>
        </PublicList>
      </div>
    </div>
  </div>
</template>

<script>
import {} from "@vue/composition-api"

import PublicList from "../base/list.vue"

import Item from "../base/item.vue"
export default {
  components: {
    PublicList,
    Item,
  },

  props: {
    img: String,
    goUrl: String,
    query:Object
  },
  setup(props,ctx) {
    const toPath = () => {
      if (props.goUrl) {
        ctx.root.$router
          .push({
            path: props.goUrl
          })
          .catch(() => { });

      }
    }
    return {toPath}
  },
}
</script>

<style scoped lang="scss">.title {
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;
}
.more::after {
  content: " >";
}</style>
